export const muiStyles = () => ({
    root: {
        width: '100%',
        height: '100%'
    }
});